import React from 'react';
import { motion } from 'framer-motion';
import '../styles/About.css';

import centerImage from '../assets/logo.png';
import video1 from '../assets/about-vid1.mp4';
import video2 from '../assets/about-vid2.mp4';
import parallaxImg from '../assets/bg14.jpeg';

const About = () => {
  return (
    <section className="about-section" id="about">
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* ABOUT US */}
      </motion.h1>

      <motion.p
        className="intro-text"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Matrix Consultancy Services is one of the leading manpower recruitment consultancy in India, supplying manpower to different industries. We have excellent connections with consultancies and industries located overseas. We are managed by professionals, senior civil servants and technocrats to assure clients of the best service, and to satisfy the need for quality manpower.
      </motion.p>

      <motion.div
        className="center-image"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <img src={centerImage} alt="Team working" />
      </motion.div>

      <motion.div
        className="section two-column"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <video
          className="video"
          src={video1}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
        <p>
          Matrix Consultancy Services is a dynamic and innovative firm dedicated to delivering comprehensive business solutions tailored to the unique needs of its clients. With a focus on strategic planning, digital transformation, and operational efficiency, Matrix helps organizations navigate challenges and seize growth opportunities. Their expert consultants work closely with clients across industries to provide insights, optimize performance, and implement sustainable change.
        </p>
      </motion.div>

      <motion.div
        className="section two-column reverse"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <video
          className="video"
          src={video2}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
        <p>
          Matrix excels in professional web designing, offering modern, responsive, and user-centric websites that enhance online presence and drive engagement. Whether it's a corporate site, e-commerce platform, or a custom web application, their design team blends creativity with functionality to craft visually compelling and technically robust solutions. With an emphasis on usability, speed, and mobile-first design, Matrix ensures each digital experience leaves a lasting impression.
        </p>
      </motion.div>

      {/* Parallax Section */}
      <div className="parallax-container">
        <div
          className="parallax-background"
          style={{ backgroundImage: `url(${parallaxImg})` }}
        />
      </div>
    </section>
  );
};

export default About;
